import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxReports from '../../utils/remote/ajaxReports';
import functions from '../../utils/functions';

const initialState = { 
    reportData: null,
    mounted: false,
    openingDate: "", 
    closingDate: "",
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }
};



const RevenueAnalysisContext = createContext();

export const RevenueAnalysisProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

 

  const getRevenueAnalysis = async (refresh) => {
    if(functions.isObject(state.reportData) && !refresh){
      return;
    }
    dispatch({ type: 'reportData', payload: null });
    const server_response  = await ajaxReports.fetchRevenueAnalysis({
      filter: {
        opening_date: state.openingDate,
        closing_date: state.closingDate,
      }
    });
    if(server_response.status === "OK"){
        dispatch({ type: 'reportData', payload: server_response.details.content });
    }else{
        dispatch({ type: 'reportData', payload: "404" });
    }
  };

 
  

  return(
    <RevenueAnalysisContext.Provider value={{
      ...state, 
      dispatch, 
      getRevenueAnalysis,
      }}>
      {children}
    </RevenueAnalysisContext.Provider>
  )

}

export const useRevenueAnalysis = ()=>useContext(RevenueAnalysisContext);

